import React from 'react';
import { Col, Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';

function RemoveTrackingComponent(props) {
  const { tracking, setTracking, initialValues, index, setInitialValues } = props;

  return (tracking > 1 ?
    <Col xs={ 6 } sm={ 6 } className="justify-content-end">
      <Button
        className="btn-icon-only rounded-circle"
        color="warning"
        style={ { marginTop: "27px" } }
        onClick={
          e => {
            e.preventDefault();
            setTracking(tracking - 1);
            let initialValuesTracking = initialValues.tracking.slice(1, index);
            setInitialValues({
              ...initialValues,
              tracking: [
                ...initialValuesTracking
              ]
            });
          }
        }
      >
        <FontAwesomeIcon icon={ faMinusCircle }/>
      </Button>
    </Col> : null
  );
}

const RemoveTracking = injectIntl(RemoveTrackingComponent)

export { RemoveTracking, RemoveTrackingComponent }
